import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

export class EipConnnectionParams {
	port: number;
	applicationInstanceId: string;

	public static fromHttpParams(params: HttpParams): EipConnnectionParams {
		const config: EipConnnectionParams = {
			port: params.get('port') ? parseInt(params.get('port')) : undefined,
			applicationInstanceId: params.get('applicationInstanceId'),
		};
		return config.port && config.applicationInstanceId ? config : null;
	}
}

@Injectable({ providedIn: 'root' })
export class EipStorage {
	init() {
		const config: EipConnnectionParams = EipConnnectionParams.fromHttpParams(getParams());
		if (config) {
			this.saveConfig(config);
			console.log('Config successfully stored');
		}
	}

	setPort(port: number): void {
		localStorage.setItem('eip.port', Number(port).toString());
	}

	getPort(): number {
		const portStr: string = localStorage.getItem('eip.port');
		return portStr ? parseInt(portStr) : undefined;
	}

	setApplicationInstanceId(id: string): void {
		localStorage.setItem('eip.applicationInstanceId', id);
	}

	getApplicationInstanceId(): string {
		return localStorage.getItem('eip.applicationInstanceId');
	}

	setConfigured(bool: boolean): void {
		return localStorage.setItem('eip.configured', bool.toString());
	}

	isConfigured(): boolean {
		const configured: string = localStorage.getItem('eip.configured');
		return configured && Boolean(configured).valueOf();
	}

	saveConfig(config: EipConnnectionParams) {
		this.setPort(config.port);
		this.setApplicationInstanceId(config.applicationInstanceId);
		this.setConfigured(!!(this.getPort() && this.getApplicationInstanceId()));
	}

	clear() {
		localStorage.removeItem('eip.port');
		localStorage.removeItem('eip.applicationInstanceId');
		localStorage.removeItem('eip.configured');
	}
}

function getParams(): HttpParams {
	const url = window.location.href;
	return url.includes('?') ? new HttpParams({ fromString: url.split('?')[1] }) : new HttpParams();
}
